'use strict';


require('select2/dist/js/select2.full.min.js');
require('./select2-dropdownPosition.js');

const { CLASSES } = require ("../utils/globals");
const SELECTORS = {
    body: 'body',
    select: '.js-select',
    selectDropdownAbove: '.js-select-dropdown-above',
    selectDropdownBelow: '.js-select-dropdown-below',
    fieldWrapper: '.js-field-wrapper',
    fieldLabel: '.js-field-label',
    timeZoneSelect: '.js-time-zone-select',
};

function resultState(data, container) {
    if (data.element) {
        $(container).addClass($(data.element).attr('class'));
    }
    return data.text;
}

/**
 * Ensure the select2 combobox exposes the field's <label> as its accessible name
 * (instead of the selected value) and conveys its required state to assistive tech.
 * Fixes WCAG 4.1.2 Name, Role, Value on the Country / State comboboxes.
 * @param {jQuery} $select - the native <select> enhanced by select2
 */
function applyAccessibility($select) {
    var $selection = $select.next('.select2-container').find('.select2-selection');
    if (!$selection.length) {
        return;
    }

    var selectId = $select.attr('id');
    var $label = selectId ? $('label[for="' + selectId + '"]') : $();
    if ($label.length) {
        var labelId = $label.attr('id');
        if (!labelId) {
            labelId = selectId + '-label';
            $label.attr('id', labelId);
        }
        // Announce the field label first, then the current value.
        var renderedId = $selection.find('.select2-selection__rendered').attr('id');
        $selection.attr('aria-labelledby', renderedId ? labelId + ' ' + renderedId : labelId);
    }

    if ($select.prop('required') || $select.hasClass('required')) {
        $selection.attr('aria-required', 'true');
    }
}

function customSelect() {
    $(SELECTORS.select).select2({
        minimumResultsForSearch: -1,
        width: '100%'
    });

    $(SELECTORS.select).each(function () {
        applyAccessibility($(this));
    });

    $(SELECTORS.selectDropdownAbove).each(function() {
        const params = {
            dropdownPosition: 'above',
            minimumResultsForSearch: -1,
            width: '100%',
            dropdownParent: $(this).parent(),
            templateResult: resultState
        };

        if ($(this).data('container-class')) {
            params.selectionCssClass = $(this).data('container-class');
        }

        if ($(this).data('data-placeholder')) {
            params.placeholder = $(this).data('data-placeholder');
        }

        $(this).select2(params);
        applyAccessibility($(this));
    });

    $(SELECTORS.selectDropdownBelow).each(function() {
        const params = {
            dropdownPosition: 'below',
            minimumResultsForSearch: -1,
            width: '100%',
            dropdownParent: $(this).parent(),
            templateResult: resultState
        };

        if ($(this).data('container-class')) {
            params.selectionCssClass = $(this).data('container-class');
        }

        if ($(this).data('data-placeholder')) {
            params.placeholder = $(this).data('data-placeholder');
        }

        $(this).select2(params);
        applyAccessibility($(this));
    });

    $(SELECTORS.timeZoneSelect).each(function() {
        $(this).select2({
            dropdownPosition: 'below',
            minimumResultsForSearch: -1,
            width: '100%',
            dropdownParent: $(this).parent()
        });
    });
}

const showLabel = ($element) => {
    const $fieldWrapper = $element.closest(SELECTORS.fieldWrapper);
    const $fieldLabel = $fieldWrapper.find(SELECTORS.fieldLabel);

    $fieldWrapper.addClass(CLASSES.placeholderUp);
    $fieldLabel.removeClass(CLASSES.animatedTransparent);
};

const labelDown = ($element) => {
    const $fieldWrapper = $element.closest(SELECTORS.fieldWrapper);
    const $fieldLabel = $fieldWrapper.find(SELECTORS.fieldLabel);

    $fieldWrapper.removeClass(CLASSES.placeholderUp);
    $fieldLabel.removeClass(CLASSES.animatedTransparent);
};

const relativeLabelsFunc = () => {
    $(`${SELECTORS.select}, ${SELECTORS.selectDropdownBelow}`).each((i, element) => {
        const $this = $(element);
        const withSelectedOption = $this.find('option:not(:first):selected').length;

        if ($this.val() && $this.val() !== '') {
            showLabel($this);
            return;
        }

        if ($this.next('.select2').find('.select2-selection__rendered').length > 0 && $this.next('.select2').find('.select2-selection__rendered').text().length == 0) {
            labelDown($this);
            return;
        }

        if (withSelectedOption) {
            showLabel($this);
            return;
        }

        $this.on('select2:select', (e) => {
            const { selected } = e.params.data;

            if (selected) {
                showLabel($this);
            }
        });
    });
};

const initEvents = () => {
    $(SELECTORS.body).on('select:reInit', () => customSelect());
    $(SELECTORS.body).on('select:labels:reInit', relativeLabelsFunc);
    $(SELECTORS.body).on('change', `${SELECTORS.select}, ${SELECTORS.selectDropdownBelow}`, relativeLabelsFunc);
};

module.exports = function () {
    initEvents();
    customSelect();
    relativeLabelsFunc();
};

module.exports.customSelect = customSelect;
